import 'bulma/css/bulma.css';
import '@fortawesome/fontawesome-free/js/all.min.js';
import './styles/variables.scss';
import './styles/globals.scss';
import './styles/icons.scss';
import App from './App.svelte';
const app = new App({
    target: document.body,
    props: {
        configPath: "/config.json",
    }
});
export default app;
